module.exports = __webpack_public_path__ + "static/img/AchievementMedal.5cdf8773.png";